module.exports = __webpack_public_path__ + "img/thumbnail-footer-calyrafit.2fd371a6.png";